interface IInputgroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export function InputGroup({ children, className = '', ...props }: IInputgroupProps) {
  return (
    <div {...props} className={`d-flex flex-column ${className}`}>
      {children}
    </div>
  );
}
